import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { webFixedVersion } from '@tb-core/helpers/next-env';

export const dataDogInitialize = (dataDogEnv: string) => {
    const dataDogClientToken = 'pubd163eb16c21e04e40d65523e7860bbcd';
    datadogRum.init({
        allowedTracingOrigins: [
            'https://tacobell.com',
            /https:\/\/.*\.tacobell\.com/,
            'https://nonprod.tb-aws.com',
            /https:\/\/.*\.nonprod\.tb-aws\.com/,
            'https://www-rel-t.test.tb-aws.com',
            /https:\/\/www-rel-t\.test\.tb-aws\.com/
        ],
        applicationId: '383aa0a3-4188-4d94-bf4b-684fdce92d8a',
        clientToken: dataDogClientToken,
        env: dataDogEnv,
        sampleRate: 15, // @TODO this should be set via GTM or other tool so it can be changed 'on the fly'
        service: 'app-web-2',
        silentMultipleInit: true,
        site: 'datadoghq.com',
        trackInteractions: true,
        trackSessionAcrossSubdomains: true,
        useSecureSessionCookie: true,
        version: webFixedVersion
    });
    datadogLogs.init({
        clientToken: dataDogClientToken,
        env: dataDogEnv,
        forwardErrorsToLogs: true,
        sampleRate: 15, // This should be set via GTM or other tool so it can be changed 'on the fly'
        service: 'app-web-2',
        silentMultipleInit: true,
        site: 'datadoghq.com',
        trackSessionAcrossSubdomains: true,
        useCrossSiteSessionCookie: true,
        useSecureSessionCookie: true,
        version: webFixedVersion
    });
    datadogLogs.logger.setLevel('warn');
};
